import Header from '../components/common/Header';
import MainSection from '../components/main/MainSection';

function Main() {
  return (
    <>
      <Header showButton />
      <MainSection />
    </>
  );
}

export default Main;
